import { render, staticRenderFns } from "./ProctoringSessionRequestor.vue?vue&type=template&id=427b82ba&scoped=true&"
import script from "./ProctoringSessionRequestor.vue?vue&type=script&lang=js&"
export * from "./ProctoringSessionRequestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b82ba",
  null
  
)

export default component.exports